<div class="pagination-bar">
  <div class="range-info">
    <span *ngIf="totalCount > 0">{{ rangeStart }}-{{ rangeEnd }} of {{ totalCount }}</span>
    <span *ngIf="totalCount === 0">No records</span>

    <select class="page-size-select" [value]="pageSize" (change)="onPageSizeSelect($any($event.target).value)">
      <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }} / page</option>
    </select>
  </div>

  <div class="page-controls" *ngIf="totalPages > 1">
    <button type="button" class="page-btn" (click)="goTo(1)" [disabled]="pageNo === 1" aria-label="First page">&laquo;</button>
    <button type="button" class="page-btn" (click)="goTo(pageNo - 1)" [disabled]="pageNo === 1" aria-label="Previous page">&lsaquo;</button>

    <button
      type="button"
      class="page-btn"
      *ngFor="let page of visiblePages"
      [class.active]="page === pageNo"
      (click)="goTo(page)"
    >
      {{ page }}
    </button>

    <button type="button" class="page-btn" (click)="goTo(pageNo + 1)" [disabled]="pageNo === totalPages" aria-label="Next page">&rsaquo;</button>
    <button type="button" class="page-btn" (click)="goTo(totalPages)" [disabled]="pageNo === totalPages" aria-label="Last page">&raquo;</button>
  </div>
</div>
